module.exports = __webpack_public_path__ + "media/assets/images/flags/mt-1be002724d460e15fc82d07399808d79.svg";